import React from "react";

import { Strong } from "@constellation/core";

import { AppContent } from "../AppContent";
import { MetaContentValues } from "../metaContentValues";



const limitedCompanyChanges: AppContent['limitedCompanyChanges'] = {
    metaContent: MetaContentValues.limitedCompanyChanges,
    pageHeading: 'Limited company changes',
    infoPanel: {
        contentSections: [
            {
                sectionHeading:
                    'Making changes to your limited company ',
                sectionBody: [
                    {
                        text: "If you're thinking about making changes to your limited company, it's important you speak to us first - even before updating Companies House.",
                    },
                ],
            },
            {
                sectionHeading:
                    'Changing a director or shareholder',
                sectionBody: [
                    {
                        text: <>Before making any changes, call us on <Strong>0345 300 2627</Strong> (Monday to Friday 8am to 8pm, Saturday 9am to 4pm. We're closed Sundays and bank holidays).                        </>,
                    },
                    {
                        text: "The mortgage must not be in arrears."
                    },
                    {
                        text: "All requests are subject to checks and any new party will need to sign a personal guarantee and obtain independent legal advice."
                    },
                    {
                        text: "To be eligible, the new party must:",
                    },
                    {
                        list: [
                            "be minimum aged 21",
                            "be a resident of England, Scotland or Wales",
                            "not increase the total number of directors or shareholders in the company to more than four."
                        ]
                    },
                    {
                        text: "The mortgage must not be in arrears",
                    },
                    {
                        text: "We may also ask for certified ID.",
                    },
                ],
            },
            {
                sectionHeading:
                    "Changes we won't accept",
                sectionBody: [

                    {
                        text: "We're unable to support the following changes to your company:"
                    },

                    {
                        list: [
                            "Converting the company into a trust, charity or foundation.",
                            "Having more than four directors or shareholders.",
                            "Adding someone under 21.",
                            "Becoming a layered company structure.",
                            "Changing your business activity to an unacceptable SIC code."
                        ]
                    },
                    {
                        text: "We only accept the following SIC codes: "
                    },
                    {
                        text: <><Strong>68209</Strong> - Other letting and operating of own or leased real estate.</>,
                    },
                    {
                        text: <><Strong>68100</Strong> - Buying and selling of own real estate.</>
                    },
                    {
                        text: <><Strong>68320 </Strong> - Management of real estate on a fee or contract basis.</>
                    },
                    {
                        text: <><Strong>68201</Strong> - Renting and operating of Housing Association real estate. </>
                    },
                    {
                        subheading: {
                            headingLevel: "h2",
                            size: "s4",
                            marginBottom: "none",
                            displayText: "Updating your details"
                        }
                    }
                ],
            },
            {
                sectionHeading:
                    "Change your direct debit",
                sectionBody: [
                    {
                        text: <>To update your direct debit details, call us on <Strong>0345 300 2627</Strong> (Monday to Friday 8am to 8pm, Saturday 9am to 4pm. We're closed Sundays and bank holidays). Or you can write to us at: </>
                    },
                    {
                        text: <>
                            Birmingham Midshires Mortgage Servicing<br />
                            PO Box 833<br />
                            Leeds<br />
                            LS1 9PU
                        </>
                    },
                    {
                        text: "Payments must come from a business bank account. We can't accept payments from personal accounts."
                    },
                ]
            },
            {
                sectionHeading:
                    "Change director or shareholder details",
                sectionBody: [
                    {
                        text: "We can accept the following changes to director and shareholder details:"
                    },
                    {
                        list: [
                            "name",
                            "address",
                            "email or phone number",
                            "correspondence address",
                            "role within the company."
                        ]
                    },
                    {
                        text: <>To make these changes, call us on <Strong>0345 300 2627</Strong> (Monday to Friday 8am to 8pm, Saturday 9am to 4pm. We're closed Sundays and bank holidays). Or you can write to us at: </>
                    },
                    {
                        text: <>
                            Birmingham Midshires Mortgage Servicing<br />
                            PO Box 833<br />
                            Leeds<br />
                            LS1 9PU
                        </>
                    },
                ]
            },
            {
                sectionHeading:
                    "Other requests ",
                sectionBody: [
                    {
                        text: "Contact us if you want to:"
                    },
                    {
                        list: [
                            "request a mortgage statement",
                            "check your mortgage balance",
                            "request a redemption statement",
                            "make an overpayment",
                            "change your mortgage term",
                            "let us know if you're experiencing financial difficulty.",
                        ]
                    },
                    {
                        text: <>Call us on <Strong>0345 300 2627</Strong> (Monday to Friday 8am to 8pm, Saturday 9am to 4pm. We're closed Sundays and bank holidays). Or you can write to us at:  </>
                    },
                    {
                        text: <>
                            Birmingham Midshires Mortgage Servicing<br />
                            PO Box 833<br />
                            Leeds<br />
                            LS1 9PU
                        </>
                    },
                ]
            },
            {
                sectionHeading:
                    "Third party authority",
                sectionBody: [
                    {
                        text: "If you'd like someone else to speak to us on your behalf, complete a third party authority form. Call us on 0345 300 2627 (Monday to Friday 8am to 8pm, Saturday 9am to 4pm. We're closed Sundays and bank holidays) to request this form."
                    },
                ]
            },
            {
                sectionHeading:
                    "Subsequent charges",
                sectionBody: [
                    {
                        text: "We do not allow subsequent charges on limited company mortgages."
                    },
                    {
                        text: "There is currently no product transfer or further advance available for limited company mortgages."
                    },
                ]
            },
        ],
    },

};

export default limitedCompanyChanges;
